<template>
  <div>
    <div class="table-ui-detail ts-space-y-2">
      <table>
        <thead>
          <tr>
            <th width="9%">{{ $t('promotion.sparePartGroup') }}</th>
            <th width="9%">{{ $t('promotion.incentiveProduct') }}</th>
            <th width="8%">{{ $t('promotion.sign') }}</th>
            <th width="8%">{{ $t('promotion.amountFrom') }}</th>
            <th width="8%">{{ $t('promotion.amountTo') }}</th>
            <th width="4%">{{ $t('promotion.discountType') }}</th>
            <th width="8%">{{ $t('promotion.discountRate') }}</th>
            <th width="4%">{{ $t('promotion.incentiveType') }}</th>
            <th width="8%">{{ $t('promotion.incentiveRate') }}</th>
            <th width="8%">{{ $t('promotion.vendorCustomer') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="max-width: 140px;">
              <a-select v-model="model_apply_all.spare_part_group_id" :options="productGroups" show-search
                mode="multiple" :maxTagCount="1" option-filter-prop="children" class="ts-w-full"
                placeholder="Select"></a-select>
            </td>
            <td class="ts-overflow-hidden ts-whitespace-no-wrap" style="max-width: 140px;">
              <a-select v-model="model_apply_all.incentive_product_id" :options="incentiveProducts" show-search
                option-filter-prop="children" class="ts-w-full" placeholder="Select"
                style="min-width: 50px;"></a-select>
            </td>
            <td>
              <a-select v-model="model_apply_all.operator_sign" class="ts-w-full" style="min-width: 80px"
                @change="operatorChange(model_apply_all)">
                <a-select-option value="=">Equal</a-select-option>
                <a-select-option value="between">Between</a-select-option>
                <a-select-option value=">=">Greater or equal</a-select-option>
              </a-select>
            </td>
            <td class="text-center ts-whitespace-no-wrap" style="min-width: 130px;">
              <ts-currency-converter-input :input_amount.sync="model_apply_all.input_amount_from"
                :amount.sync="model_apply_all.amount_from" :input_currency_id.sync="model_apply_all.input_currency_id"
                :currency_id.sync="model_apply_all.currency_id" :fx_rate.sync="model_apply_all.fx_rate"
                :fx_rate_ratio.sync="model_apply_all.fx_rate_ratio" style="min-width: 60px;" />
            </td>
            <td class="text-center ts-whitespace-no-wrap" style="min-width: 130px;">
              <ts-currency-converter-input :input_amount.sync="model_apply_all.input_amount_to"
                :amount.sync="model_apply_all.amount_to" :input_currency_id.sync="model_apply_all.input_currency_id"
                :currency_id.sync="model_apply_all.currency_id" :fx_rate.sync="model_apply_all.fx_rate"
                :fx_rate_ratio.sync="model_apply_all.fx_rate_ratio" style="min-width: 60px;" />
            </td>
            <td style="min-width: 80px;">
              <a-select v-model="model_apply_all.discount_type" class="ts-w-full" style="min-width: 50px"
                @change="onChangeItem(model_apply_all)">
                <a-select-option value="%">%</a-select-option>
                <a-select-option :value="getDiscountCurrency(model_apply_all.input_currency_id)">
                  {{ getDiscountCurrency(model_apply_all.input_currency_id) }}
                </a-select-option>
              </a-select>
            </td>
            <td style="min-width: 130px;">
              <input v-if="model_apply_all.discount_type == '%'" ref="discountRate" type="number"
                v-model.number="model_apply_all.input_discount_rate" class="form-control"
                @change="onChangeItem(model_apply_all)" />
              <ts-currency-converter-input v-else :input_amount.sync="model_apply_all.input_discount_rate"
                :amount.sync="model_apply_all.discount_rate" :input_currency_id.sync="model_apply_all.input_currency_id"
                :currency_id.sync="model_apply_all.currency_id" :fx_rate.sync="model_apply_all.fx_rate"
                :fx_rate_ratio.sync="model_apply_all.fx_rate_ratio" style="min-width: 120px;" />
            </td>
            <td style="min-width: 80px;">
              <a-select v-model="model_apply_all.incentive_type" class="ts-w-full" style="min-width: 50px"
                @change="onChangeItem(model_apply_all)">
                <a-select-option value="%">%</a-select-option>
                <a-select-option :value="getDiscountCurrency(model_apply_all.input_currency_id)">
                  {{ getDiscountCurrency(model_apply_all.input_currency_id) }}
                </a-select-option>
              </a-select>
            </td>
            <td style="min-width: 130px;">
              <input v-if="model_apply_all.incentive_type == '%'" ref="incentiveRate" type="number"
                v-model.number="model_apply_all.input_incentive_rate" class="form-control"
                @change="onChangeItem(model_apply_all)" />
              <ts-currency-converter-input v-else :input_amount.sync="model_apply_all.input_incentive_rate"
                :amount.sync="model_apply_all.incentive_rate"
                :input_currency_id.sync="model_apply_all.input_currency_id"
                :currency_id.sync="model_apply_all.currency_id" :fx_rate.sync="model_apply_all.fx_rate"
                :fx_rate_ratio.sync="model_apply_all.fx_rate_ratio" style="min-width: 120px;" />
            </td>
            <td style="min-width: 120px;max-width: 150px;">
              <a-select v-model="model_apply_all.vendor_customer_id" :options="customers" show-search
                option-filter-prop="children" class="ts-w-full" placeholder="Select" @search="handleSearch"></a-select>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
          <ts-button @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button @click.prevent="onApply" color="primary">
            {{ $t('apply') }}
          </ts-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'invcentiveByAmountCondition',
  props: ['value'],
  data() {
    return {
      loading: false,
      show_apply_all: false,
      model: {},
      model_apply_all: {
        spare_part_group_id: [],
        operator_sign: null,
        amount_from: null,
        input_amount_from: null,
        amount_to: null,
        input_amount_to: null,
        currency_id: null,
        input_currency_id: null,
        fx_rate: 1,
        fx_rate_ratio: 1,
        discount_type: '%',
        discount_rate: 0,
        input_discount_rate: 0,
        incentive_type: '%',
        incentive_rate: 0,
        input_incentive_rate: 0,
        incentive_product_id: null,
        vendor_customer_id: null,
      },
    }
  },
  created() {
    this.model = this.value
    this.setDefaultCurrency()
  },
  computed: {
    ...mapState('promotion/incentiveByAmount', ['formViewDatas']),
    productGroups() {
      if (this.formViewDatas['productGroups']) {
        return this.formViewDatas['productGroups']
          .map(el => ({
            value: el.pro_group_id,
            label: el.pro_group_name_en
          }))
      }
      return []
    },
    incentiveProducts() {
      if (this.formViewDatas['incentiveProducts']) {
        return this.formViewDatas['incentiveProducts'].map(el => ({
          value: el.product_id,
          label: el.product_name_en
        }))
      }
      return []
    },
    customers() {
      if (this.formViewDatas['customers']) {
        return this.formViewDatas['customers'].map(el => ({
          value: el.customer_id,
          label: el.customer_name
        }))
      }
      return []
    },
  },
  methods: {
    ...mapActions('promotion/incentiveByAmount', ['getFormViewModel']),
    handleSearch: debounce(async function (value) {
      this.loading = true
      await this.getFormViewModel({
        index: 'customers',
        params: {
          fnName: 'customers',
          search_customer: value,
          customer_id: this.model.condition.map(el => el.vendor_customer_id)
        }
      })
      this.loading = false
    }, 800),
    onApply() {
      this.model.condition.forEach(product => {
        product.spare_part_group_id = this.model_apply_all.spare_part_group_id
        product.incentive_product_id = this.model_apply_all.incentive_product_id
        product.operator_sign = this.model_apply_all.operator_sign
        product.amount_from = this.model_apply_all.amount_from
        product.input_amount_from = this.model_apply_all.input_amount_from
        product.amount_to = this.model_apply_all.amount_to
        product.input_amount_to = this.model_apply_all.input_amount_to
        product.currency_id = this.model_apply_all.currency_id
        product.input_currency_id = this.model_apply_all.input_currency_id
        product.fx_rate = this.model_apply_all.fx_rate
        product.fx_rate_ratio = this.model_apply_all.fx_rate_ratio
        product.discount_type = this.model_apply_all.discount_type
        product.discount_rate = this.model_apply_all.discount_rate
        product.input_discount_rate = this.model_apply_all.input_discount_rate
        product.incentive_type = this.model_apply_all.incentive_type
        product.incentive_rate = this.model_apply_all.incentive_rate
        product.input_incentive_rate = this.model_apply_all.input_incentive_rate
        product.vendor_customer_id = this.model_apply_all.vendor_customer_id
      });
    },
    setDefaultCurrency() {
      let default_currency = this.$store.state.exchangeRate.currency.formViewDatas['default']

      this.model_apply_all.spare_part_group_id = []
      this.model_apply_all.incentive_product_id = null
      this.model_apply_all.operator_sign = null
      this.model_apply_all.amount_from = null
      this.model_apply_all.input_amount_from = null
      this.model_apply_all.amount_to = null
      this.model_apply_all.input_amount_to = null
      this.model_apply_all.currency_id = default_currency
        ? default_currency.currency_id
        : null
      this.model_apply_all.input_currency_id = default_currency
        ? default_currency.currency_id
        : null
      this.model_apply_all.fx_rate = 1
      this.model_apply_all.fx_rate_ratio = 1
      this.model_apply_all.discount_type = '%'
      this.model_apply_all.discount_rate = 0
      this.model_apply_all.input_discount_rate = 0
      this.model_apply_all.incentive_type = '%'
      this.model_apply_all.incentive_rate = 0
      this.model_apply_all.input_incentive_rate = 0
      this.model_apply_all.vendor_customer_id = null
    },
    getDiscountCurrency(input_currency_id) {
      if (this.formViewDatas['currency']) {
        return this.formViewDatas['currency'].find(
          el => el.currency_id == input_currency_id
        ).currency_symbol
      }
      return null
    },
    operatorChange(row) {
      if (row.operator_sign != 'between') {
        row.amount_to = null
        row.input_amount_to = null
      }
    },
    onChangeItem(product) {
      if (product.discount_type == '%') {
        product.discount_rate = product.input_discount_rate
      } else {
        product.discount_type = this.getDiscountCurrency(product.input_currency_id)
        product.discount_rate = product.input_discount_rate * product.fx_rate_ratio
      }

      if (product.incentive_type == '%') {
        product.incentive_rate = product.input_incentive_rate
      } else {
        product.incentive_type = this.getDiscountCurrency(product.input_currency_id)
        product.incentive_rate = product.input_incentive_rate * product.fx_rate_ratio
      }
    },
  },
}
</script>